import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import styles from './style.module.less'
import classNames from 'classnames'
import { getObjValue, ctrlTextLen } from '@hlj/hlj-utils'
import { Tooltip } from 'hljd'
import { getSizedImgUrl } from '@util'
import { getLink, getContent } from '../../config'

@inject('store')
@observer
export default class extends Component {
  getItem = item => {
    const { getNoticeName, getMessage, goto } = this.props.store
    const { notify_type, action, entity } = item
    const tranObj = getNoticeName(notify_type, entity, item)
    const message = getMessage(item)
    const noticeContent = getContent(item)
    const linkUrl = getLink(item)
    let qa_content = '' // 问答的内容

    if (notify_type == 16) {
      if (action == 'qa_answer_merchant') {
        qa_content = item.content || ''
      }
      if (action == 'qa_question_merchant') {
        qa_content = getObjValue(item, 'extra_objects.expand.title')
      }
    }

    const iconStyle = tranObj.icon
      ? {
          backgroundImage: 'none'
        }
      : {}

    return (
      <li
        className={classNames(styles.item, {
          [styles.itemPointer]: !!linkUrl
        })}
        key={item.id}
        onClick={() => goto(item, message, linkUrl)}
      >
        <div
          className={classNames(
            styles.itemLeft,
            styles[tranObj.style === 'notice_17' ? '' : tranObj.style]
          )}
          style={{ ...iconStyle }}
        >
          {item.status != 2 ? <span className={styles.dot} /> : ''}
          {(tranObj.icon ||
            (tranObj.style === 'notice_17' && item.participant_avatar)) && (
            <img
              src={getSizedImgUrl({
                src: item.participant_avatar,
                width: 128,
                height: 128
              })}
              width="64"
              style={{ borderRadius: '50%', marginTop: 27 }}
            />
          )}
        </div>
        <div className={styles.itemRight}>
          <p className={styles.time}>
            <span className={styles.itemF}>{tranObj.name}</span>
            <span className={styles.itemR}>{item.created_at}</span>
          </p>
          <div className={styles.tip}>
            {notify_type == 16 &&
            (action == 'qa_question_merchant' ||
              action == 'qa_answer_merchant') ? (
              <div>
                <Tooltip title={noticeContent} style={{ marginBottom: 5 }}>
                  {ctrlTextLen(noticeContent, 50)}
                </Tooltip>
                <Tooltip
                  title={qa_content}
                  className={classNames(styles.question, {
                    [styles.answer]: action == 'qa_answer_merchant'
                  })}
                >
                  {qa_content && <span>"{ctrlTextLen(qa_content, 60)}"</span>}
                </Tooltip>
              </div>
            ) : (
              <Tooltip title={noticeContent}>
                {notify_type == 23
                  ? ctrlTextLen(noticeContent, 100)
                  : ctrlTextLen(noticeContent, 90)}
              </Tooltip>
            )}
          </div>
          {!!linkUrl && <span className={styles.detail}>查看详情</span>}
        </div>
      </li>
    )
  }
  render() {
    const { noticeList } = this.props.store

    let items = noticeList.map(item => this.getItem(item))
    return (
      <ul className={styles.list}>
        {noticeList.length > 0 ? (
          items
        ) : (
          <p className={styles.noNotice}>暂无通知</p>
        )}
      </ul>
    )
  }
}
